.body {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 16px;
}

.error {
  color: var(--color-destructive);
}
